import { render, staticRenderFns } from "./Exhibitions.vue?vue&type=template&id=762c0040&scoped=true"
import script from "./Exhibitions.vue?vue&type=script&lang=js"
export * from "./Exhibitions.vue?vue&type=script&lang=js"
import style0 from "./Exhibitions.vue?vue&type=style&index=0&id=762c0040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762c0040",
  null
  
)

export default component.exports